<div class="number-field-container container" [formGroup]="form">
  <mat-form-field class="form-field" appearance="outline">
    <input
      matInput
      type="number"
      [placeholder]="'ENTER_EXPECTED_SQUARE_FOOTAGE' | translate"
      [formControlName]="controlName"
      [required]="isRequired"
      (keydown)="blockNonNumeric($event)"
    />

    <mat-error *ngIf="form.get(controlName).hasError('max')">
      <i>{{ 'NUMBER_FIELD_ERROR.MAX' | translate: { value: form.get(controlName).getError('max').max.toLocaleString() } }}</i>
    </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('min')">
      <i>{{ 'NUMBER_FIELD_ERROR.MIN' | translate: { value: form.get(controlName).getError('min').min.toLocaleString() } }}</i>
    </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('required')">
      <i *ngIf="!requiredMessage">{{ 'NUMBER_FIELD_ERROR.REQUIRED' | translate }}</i>
      <i *ngIf="requiredMessage">{{ requiredMessage }}</i>
    </mat-error>
  </mat-form-field>
</div>